import * as ifr from "./action-type";

// 是否允许渲染
export const updateAllowPaint = data => {
    return {
        type: ifr.ALLOWPAINT,
        data
    };
};
